import { SwiperOptions } from 'swiper';

/**
 * Remplace `navigation: true` par les flèches présentes dans le conteneur du carrousel, que Swiper ne retrouve pas seul.
 */
export const withNavigationButtons = (
  config: SwiperOptions,
  container: HTMLElement,
): SwiperOptions =>
  config.navigation === true
    ? {
        ...config,
        navigation: {
          prevEl: container.querySelector<HTMLElement>('.swiper-button-prev'),
          nextEl: container.querySelector<HTMLElement>('.swiper-button-next'),
        },
      }
    : config;
